import React from "react";
import PropTypes from "prop-types";
import Select, {components} from "react-select";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import take from "lodash/take";
import isArray from "lodash/isArray";
import s from "./MentorFilters.pcss";

const classMap = {
    0: s.left,
    1: s.middle,
    2: s.middle,
    3: s.right,
};

const customStyles = {
    control: base => ({
        ...base,
        backgroundColor: "white",
    }),
    placeholder: base => ({
        ...base,
        // because React Select uses an actual element instead of a placeholder attribute we set
        // an accessible colour here
        color: "#585858",
    }),
};

const presetFilterLabelMap = {
    country: "countries",
    degree: "areaOfStudy",
    degree_level: "degreeLevel",
    institution: "institution",
};

const Option = components.Option;

const MentorFilters = props => {
    const {t} = useTranslation("mentorCard");
    const institutionFilter = props.filters.find(filter => filter.id === "institution");

    return (
        <div className={s.container}>
            {take(props.filters, institutionFilter ? 4 : 3).map((f, i) => {
                const filterLabel = presetFilterLabelMap[f.id]
                    ? t(presetFilterLabelMap[f.id], f.label)
                    : f.label;

                return (
                    <div key={f.id} className={classNames(s.filter, classMap[i])}>
                        <Select
                            id={`mentor-filter-${f.id}`}
                            data-test-id={f.id}
                            name={f.id}
                            placeholder={filterLabel}
                            options={f.options.map(({id, label}) => ({value: id, label}))}
                            onChange={value => {
                                if (isArray(value) && value.length === 0) {
                                    return;
                                }
                                props.addFilter(f, value);
                            }}
                            clearable={false}
                            aria-label={filterLabel}
                            styles={customStyles}
                            components={{
                                Option: optionProps => (
                                    <Option
                                        {...optionProps}
                                        // adding classname for testing, since Option comp takes only few and ignores any custom prop
                                        className={`${
                                            optionProps.className
                                        } e2e-test-mentor-filter-${f.label}-option`}
                                    />
                                ),
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

MentorFilters.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    addFilter: PropTypes.func.isRequired,
    filters: PropTypes.array,
};

MentorFilters.defaultProps = {
    filters: [],
};

export default MentorFilters;
